<template>
  <Layout>
    <main>
      <section>
        <v-hero :imageSource="heroImage" showBackgroundImage>
          <div>
            <img
              :class="{
                [$style['logo']]: true,
                [$style['wide']]: widerLogo,
              }"
              :src="`https:${logo}`"
            />
          </div>
        </v-hero>
      </section>
      <section :class="$style['body']">
        <h1
          v-if="locationTitle"
          v-text="locationTitle"
          v-color="colorFontHeading"
          v-font-style="fontDetailHeading"
        />
        <the-geolocate-input
          :colorFontBody="colorFontBody"
          :fontBody="fontDetailBody"
          :geolocationLoadingStatus="geolocationLoadingStatus"
          :label="locationLabel"
          :queryLoadingStatus="queryLoadingStatus"
          @blur="handleBlur"
          @focus="handleFocus"
          @geolocate="handleGeolocate"
          @submitQuery="handleSubmitQuery"
        />
        <v-dropdown
          v-if="nearestLocations.length > 0"
          :colorFont="colorFontBody"
          :fontDetail="fontDetailBody"
          :fontDetailHeading="fontDetailHeading"
          :colorBackground="colorBackground"
          :colorBackgroundHeading="colorSecondary"
          :list="nearestLocations"
          title="CHOOSE YOUR RESTAURANT"
          @select="handleSelectLocation"
        ></v-dropdown>
      </section>
      <section :class="$style['footer']">
        <base-link :to="{ path: '/terms-and-conditions' }">
          <p
            :class="$style['terms-link']"
            v-color="colorFontBody"
            v-font-style="fontDetailBody"
            >Terms and conditions</p
          >
        </base-link>
      </section>
    </main>
  </Layout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash.get'
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import TheGeolocateInput from '@components/the-geolocate-input.vue'
import VHero from '@components/v-hero.vue'
import VDropdown from '@components/v-dropdown.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    TheGeolocateInput,
    VHero,
    VDropdown,
  },
  computed: {
    ...mapGetters('contentful', [
      'hasMoreThanOneLocation',
      'colorBackground',
      'colorFontBody',
      'colorFontHeading',
      'colorSecondary',
      'fontDetailBody',
      'fontDetailHeading',
      'heroImage',
      'locationLabel',
      'locationTitle',
      'logo',
      'widerLogo',
      'singleRestaurantSlug',
      'contentfulLoadingStatus',
    ]),
    ...mapGetters('location', [
      'geolocationLoadingStatus',
      'nearestLocations',
      'queryLoadingStatus',
    ]),
    ...mapGetters('ui', ['showLocationModal']),
  },
  methods: {
    ...mapActions('location', [
      'handleGeolocate',
      'handleSubmitQuery',
      'setNearestLocations',
    ]),
    ...mapActions('ui', ['setPageLoadingStatus', 'toggleLocationModal']),
    handleBlur() {},
    handleFocus() {},
    handleSelectLocation(location) {
      const slug = get(location, 'fields.slug')
      this.setPageLoadingStatus('loading')
      this.toggleLocationModal({ modalIsVisible: false })
      this.setNearestLocations([])
      if (slug) {
        return this.$router.push(`/${slug}`)
      }
      this.setPageLoadingStatus('loaded')
    },
    init() {
      this.setPageLoadingStatus('loading')

      if (!this.hasMoreThanOneLocation) {
        return this.pushToLocation()
      }

      this.setPageLoadingStatus('loaded')
    },
    pushToLocation() {
      const slug = this.singleRestaurantSlug
      this.$router.replace({ path: slug })
    },
  },
  watch: {
    contentfulLoadingStatus(newVal) {
      if (newVal === 'loaded') {
        this.init()
        console.log('host', window.location.hostname)
      }
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

main {
  position: relative;
}

.logo {
  width: 30%;
  margin-top: 24px;

  &.wide {
    width: 50%;
  }
}

.body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 31px 0;
}

.footer {
  width: 100%;
  padding-bottom: 16px;
  padding-top: 8px;
  .terms-link {
    font-size: 12px;
    text-align: center;
    text-decoration: underline;
  }
}

@media screen and (min-height: 700px) {
  .footer {
    bottom: 0;
    position: fixed;
  }
}
</style>
